import { useMemo } from 'react'
import { Provider } from 'react-redux'
import { createStore } from './store'

const StateProvider = (props) => {
  const { initialState, children } = props
  // Force recreate store when initialData changes, e.g when switching workspaces
  const store = useMemo(() => createStore(initialState), [initialState])
  return <Provider store={store}>{children}</Provider>
}

export { StateProvider }
export default StateProvider
